<script setup lang="ts">
import type { IElement } from '~/interfaces/form/formBuilder';
import type { Dayjs } from 'dayjs';
defineProps<{
  element: IElement;
  maxCalDate?: Dayjs;
  minCalDate?: Dayjs;
  disableCal?: boolean;
  formErrors?: { [key: string]: string };
}>();
const model = defineModel<Dayjs>();
const { $t } = useNuxtApp();
const site = useSiteStore();
const { bdayLock } = useRegistrationState();
</script>
<template>
  <div
    class="relative min-w-full"
    :class="{ 'cursor-not-allowed': disableCal }"
  >
    <div class="relative w-full flex flex-col gap-1">
      <label class="text-base-priority text-sm pl-1" :for="element.id">
        {{
          $t(
            `label.${element.label}-${site.getRegionCode}`,
            `label.${element.label}`,
          )
        }}
      </label>
      <DesignSystemInputsDatePicker
        :id="element.id"
        v-model:date="model"
        :placeholder="
          $t(
            `placeholder.${element.placeholder}-${site.getRegionCode}`,
            `placeholder.${element.placeholder}`,
          )
        "
        :min-date="maxCalDate"
        :max-date="minCalDate"
        :disabled="bdayLock || disableCal"
        :hide-reset-over-ride="true"
      />
    </div>
  </div>
</template>
